/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Future",
  size: 20
}

const SvgFuture = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path d="M19 2h-1v4h-4v1h5V2" />
    <path
      fill="none"
      strokeWidth={1.1}
      d="M18 6.548C16.709 3.29 13.354 1 9.6 1c-5 0-9 4-9 9s4 9 9 9 9-4 9-9"
    />
    <path d="M9 4h1v7H9z" />
    <path d="M13.018 14.197l-3.573-3.572" fill="none" strokeWidth={1.1} />
  </Svg>
)

SvgFuture.defaultProps = defaultProps
export default SvgFuture
